import { Controller } from "@hotwired/stimulus"
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static values = { date: String }

  async toggle(event) {
    let request;

    if (event.target.checked) {
      request = new FetchRequest("patch", `/goal_completions/${event.target.dataset.goalCompletionId}`, {
        body: JSON.stringify({
          completed: true
        })
      })
    } else {
      request = new FetchRequest("patch", `/goal_completions/${event.target.dataset.goalCompletionId}`, {
        body: JSON.stringify({
          completed: false
        })
      })
    }

    const response = await request.perform();
    if (response.ok) {
      // Dispatch event to notify charts to update with date information
      const eventData = {
        date: this.dateValue || this.getCompletionDateFromResponse(response) || null
      };
      document.dispatchEvent(new CustomEvent('goal-completion:updated', { detail: eventData }));
    }
  }

  // Try to extract date from the response if possible
  getCompletionDateFromResponse(response) {
    try {
      const data = response.json;
      if (data && data.created_at) {
        return new Date(data.created_at).toISOString().split('T')[0];
      }
      return null;
    } catch(e) {
      console.error("Error extracting date from response:", e);
      return null;
    }
  }
}


